/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import { Text } from 'hocs/localization'
import classNames from 'classnames/bind'
import { selectPlanScroller, benefitsScroller } from 'services/PageScroller'
import { ROUTES } from 'constants/routes'
import { HEADER_PAGES, MENU_ITEM_NAMES } from 'constants/header'
import Button from 'elements/Button'
import HeaderMenu  from './apps/HeaderMenu'
import HeaderActions  from './apps/HeaderActions'
import MobileMenu  from './apps/MobileMenu'
import Icon from 'elements/Icon'
import * as styles from './Header.scss'
import Logo from './assets/header-new-logo.png'

const cx = classNames.bind(styles)

interface IProps extends RouteComponentProps {
  isUserAuthorized: boolean,
  styleType?: string,
  page: HEADER_PAGES,
  t: Text,
  setScrollElementId: (elementId: string | null) => void,
  onGetSubscriptionsPlans: () => any,
}

interface IState {
  isMobileMenuVisible: boolean,
}

class Header extends React.Component<IProps, IState> {
  public readonly state = {
    isMobileMenuVisible: false,
  }

  private toggleMobileMenu = () => {
    this.setState({
      isMobileMenuVisible: !this.state.isMobileMenuVisible,
    })
  }

  private onCloseMobileMenu = () => {
    this.setState({
      isMobileMenuVisible: false,
    })
  }

  private onClickMenuItem = (event, name) => {
    const { history, setScrollElementId } = this.props
    event.preventDefault()
    if (name === MENU_ITEM_NAMES.plans) {
      history.push(ROUTES.home.home)
      setScrollElementId(selectPlanScroller.getElementId())
      this.onCloseMobileMenu()
      return
    }
    if (name === MENU_ITEM_NAMES.benefits) {
      history.push(ROUTES.home.home)
      setScrollElementId(benefitsScroller.getElementId())
      this.onCloseMobileMenu()
      return
    }
    if (name === MENU_ITEM_NAMES.contactUs) {
      history.push(ROUTES.home.contactUs)
      this.onCloseMobileMenu()
      return
    }
    if (name === MENU_ITEM_NAMES.login) {
      history.push(ROUTES.home.logIn)
      this.onCloseMobileMenu()
      return
    }
    if (name === MENU_ITEM_NAMES.signUp) {
      history.push(ROUTES.home.home)
      setScrollElementId(selectPlanScroller.getElementId())
      this.onCloseMobileMenu()
      return
    }
  }

  public render () {
    const { styleType, page, t, isUserAuthorized } = this.props

    return(
      <div className={cx('TopHead', styleType)}>
        <div className='container-fluid'>
          <div className={cx('no-gutters', styles.row)}>
            <div className='col-lg-8 col-md-12 col-sm-12'>
              <div className={styles.TopMenu}>
                <Link to={ROUTES.home.root}>
                  <img src={Logo} alt='EPSON Logo' />
                </Link>
                <button onClick={this.toggleMobileMenu} className={styles.togglebutton}>
                  <Icon name='bars'/>
                </button>
                <HeaderMenu page={page} onClickMenuItem={this.onClickMenuItem} />
              </div>
            </div>

            {!isUserAuthorized && (
              <div className='col-md-4 text-right'>
                <div className={styles.authButtons}>
                  <div className={styles.authButton}>
                    <Button
                      styleType='secondary'
                      onClick={event => this.onClickMenuItem(event, MENU_ITEM_NAMES.login)}
                      fluid
                    >
                      {t('logIn')}
                    </Button>
                  </div>
                  <div className={styles.authButton}>
                    <Button
                      onClick={event => this.onClickMenuItem(event, MENU_ITEM_NAMES.signUp)}
                      fluid
                    >
                      {t('signUp')}
                    </Button>
                  </div>
                </div>
              </div>
            )}

            <div className={cx('col-lg-4', 'col-md-12')}>
              <MobileMenu
                isVisible={this.state.isMobileMenuVisible}
                page={page}
                onClickMenuItem={this.onClickMenuItem}
              />
              <HeaderActions />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Header
